<template>
  <div>
    <v-layout row wrap>
      <v-flex
        xs6
        sm5
        md3
        lg2
        class="pr-5"
      >
        <v-autocomplete
          ref="providerName"
          v-model="provider.name"
          :loading="loadingProvider > 0"
          :items="activeProvidersData"
          :label="$t('editingContainer.providerName')"
          :item-text="(p) => p.name"
          :rules="[rules.required]"
          required
          :name="$t('editingContainer.providerName')"
          @change="onChangeProviderName"
        />
      </v-flex>
      <v-flex xs6 sm5 md2 lg1>
        <v-combobox
          ref="color"
          v-model="provider.color"
          :items="colors"
          item-text="name"
          :label="$t('editingContainer.color')"
          chips
          dense
          :rules="[rules.required]"
          height="32px"
          browser-autocomplete="off"
          required
          :name="$t('editingContainer.providerColor')"
        >
          <template slot="selection" slot-scope="data">
            <v-chip
              small
              :color="data.item.color ? data.item.color.toLocaleLowerCase() : data.item.toLocaleLowerCase()"
              text-color="white"
            >
              {{ data.item.name ? data.item.name : data.item }}
            </v-chip>
          </template>
        </v-combobox>
      </v-flex>
    </v-layout>
    <v-divider />
  </div>
</template>

<script>
import ValidationService from '@/services/ValidationService';

export default {
  name: 'ProviderSettings',
  props: {
    provider: {
      type: Object,
      required: true,
    },
    activeProvidersData: {
      type: Array,
      required: true,
    },
    loadingProvider: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedColor: null,
      rules: {
        required: ValidationService.rules.required(),
      },
      colors: ['Red', 'Green'],
      search: null,
    };
  },
  methods: {
    validate() {
      const result = ValidationService.validate(Object.keys(this.$refs)
        .filter(k => k === 'providerName' || k === 'color')
        .map(k => this.$refs[k]));

      return result;
    },
    onTimeChange(newValue) {
      this.provider.orderUntilHour = newValue;
    },
    onDateChange(newValue) {
      this.provider.orderUntilDay = newValue;
    },
    onChangeProviderName(providerName) {
      const selectedProviderData = this.activeProvidersData.find(ap => ap.name === providerName);
      this.provider.providerDataId = selectedProviderData.id;
    },
  },
};
</script>
